import tippy from 'tippy.js';

export default class Footnotes {
	constructor() {
		this.tippies = [];

		document.addEventListener('bless', ({ detail }) => {
			this.init(detail.next.container);
		});
	}

	init(container) {
		// Destroy previous tippies
		if (this.tippies) {
			this.tippies.forEach(tippy => {
				tippy.destroy();
			});

			this.tippies = [];
		}

		const footnotes = container.querySelectorAll('.c-footnote');

		footnotes.forEach((footnote, index) => {
			const content = JSON.parse(footnote.dataset.content);

			const footnoteTippy = tippy(footnote, {
				content: content,
				allowHTML: true,
				interactive: true,
				placement: 'top',
				theme: 'emergence-footnotes',
				animation: 'fade',
				onShow(instance) {
					instance.reference.classList.add('c-footnote--visible');
				},
				onHide(instance) {
					instance.reference.classList.remove('c-footnote--visible');
				},
			});

			this.tippies.push(footnoteTippy);
		});
	}
}
